import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCsv } from "../../utils";

export const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    Nome: item.name,
    Telefone: item.phone,
    Celular: item.cellPhone,
    "E-mail": item.email,
    Função: item.roleUser.name,
    Laboratório:
      item.sectorsUsers[0] && item.sectorsUsers[0].sector.lab
        ? item.sectorsUsers?.map((sectorLabs) => sectorLabs.sector.lab?.name)
        : "",
    "Data de Cadastro": item.registeredAt
      ? moment(item.registeredAt).format("DD/MM/YYYY")
      : "",
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: ["Nome", "Telefone", "E-mail", "Função", "Laboratório", "Data de Cadastro"],
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "representatives");
};
